import { TYPOGRAPHY } from '../../styles/theme-config/themeConstants';

/** @type {import("@mui/material").SxProps<typeof import('@mui/material/styles').Theme>} */
export const useStyles = (
  theme,
  infoTileMobile,
  infoTileDesktop,
  infoTileTablet,
  infoTileForegroundDesktop,
  infoTileForegroundMobile,
  infoTileForegroundTablet,
) => ({
  InfoMain: {
    m: '0 auto',
    p: '0 1.5rem',
    justifyContent:
      infoTileForegroundDesktop || infoTileForegroundMobile || infoTileForegroundTablet
        ? 'space-between'
        : 'center',
    [theme.breakpoints.down('sm')]: {
      p: 0,
    },
  },
  InfoContainer: {
    [theme.breakpoints.down('sm')]: {
      background: `url(${infoTileMobile}) no-repeat center/cover`,
      backgroundColor: theme.palette.backgroundColor,
      minHeight: '35rem',
    },
    [theme.breakpoints.up('sm')]: {
      background: `url(${infoTileTablet}) right/cover no-repeat`,
      backgroundColor: theme.palette.backgroundColor,
    },
    [theme.breakpoints.up('md')]: {
      background: `url(${infoTileDesktop}) 100% 100%/cover no-repeat `,
      backgroundColor: theme.palette.backgroundColor,
      justifyContent: 'space-around',
    },
  },
  InfoDetails: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
    },
  },
  InfoBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      p: '1.938rem 1rem 1.938rem 1rem',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      pl: '4.1rem',
      pb: '1rem',
    },
  },
  infoText: {
    pt: '3.875rem',
    [theme.breakpoints.down('sm')]: {
      pt: 0,
    },
  },
  infoTextAlign: {
    textAlign: 'center',
    pt: '1rem',
    [theme.breakpoints.down('sm')]: {
      pt: '1.5rem',
    },
  },
  InfoTitle: {
    color: theme?.palette?.textHeading,
    letterSpacing: 'inherit',

    [theme.breakpoints.down('sm')]: {
      p: '2rem 2rem 0 2rem',
    },
  },
  InfoDescription: {
    pt: '1rem',
    /* TBU subtitle 3 is introduced in theme as apart of accesibility project EDQ-6937 */
    fontWeight: TYPOGRAPHY?.h6?.fontWeight,
    fontSize: TYPOGRAPHY?.body3Medium?.fontSize,
    fontFamily: TYPOGRAPHY?.h6?.fontFamily,
    color: theme?.palette?.textBody,
    letterSpacing: 'inherit',
    [theme.breakpoints.down('sm')]: {
      p: '2rem 2rem 0 2rem',
    },
  },
  InfoCTA: {
    p: '1.5rem 0 3.875rem 0',
    [theme.breakpoints.down('sm')]: {
      p: '2rem 3rem 0 3rem',
    },
  },
  InfoCenterAlign: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme?.palette?.backgroundColor,
  },
  InfoBoxCenter: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    pt: '2.4rem',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      p: '2rem 1rem 1.938rem 1rem',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      textAlign: 'center',
      pb: '1rem',
    },
  },
  ForegroundImageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    p: 0,
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
      alignItems: 'flex-start',
      pb: '3.44rem',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      justifyContent: 'center',
    },
  },
  ForegroundImage: {
    width: '10.106rem',
    height: '10.106rem',
    [theme.breakpoints.up('md')]: {
      background: `url(${infoTileForegroundDesktop}) 100% 100%/cover no-repeat`,
    },
    [theme.breakpoints.down('sm')]: {
      background: `url(${infoTileForegroundMobile}) no-repeat center/cover `,
      width: '6rem',
      height: '6rem',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      background: `url(${infoTileForegroundTablet}) right/cover no-repeat`,
    },
  },
});
